import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.querySelector('#compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-[#F8FAFC]" data-id="element-218">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-219">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-amber-100/50 blur-3xl" data-id="element-220" />
        <div className="absolute top-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-blue-100/50 blur-3xl" data-id="element-221" />
      </div>

      {/* ABOVE THE FOLD — fits one iPhone screen */}
      <div className="min-h-[100svh] flex flex-col justify-center items-center px-4 py-6 md:py-20 relative z-10" data-id="element-222">
        <div className="w-full max-w-5xl mx-auto flex flex-col items-center" data-id="element-223">
          {/* Pre-headline */}
          <p className="text-[11px] md:text-base font-semibold text-[#F59E0B] tracking-wide uppercase bg-amber-100 inline-block px-3 py-1 md:px-4 md:py-1.5 rounded-full text-center mb-3 md:mb-6 leading-snug" data-id="element-224">
            Para maestras de primaria que se quedan hasta tarde preparando
            material… y siguen sintiendo que nunca alcanza el tiempo
          </p>

          {/* Main headline */}
          <h1 className="text-[22px] leading-[1.2] md:text-5xl lg:text-6xl font-extrabold text-[#1E3A5F] md:leading-tight mb-2 md:mb-4 text-center max-w-4xl" data-id="element-225">
            ¿Te cuesta que tus alumnos realmente comprendan lo que leen?
          </h1>
          <p className="text-[14px] leading-snug md:text-xl lg:text-2xl font-medium text-slate-500 text-center max-w-3xl mb-4 md:mb-10" data-id="element-226">
            Con este Plan Lector para Primaria (1ro a 6to) tenés un sistema
            completo para que tus niños no solo lean… sino que comprendan, con
            material listo para aplicar todo el año.
          </p>

          {/* Product mockup image */}
          <div className="flex justify-center mb-3 md:mb-10" data-id="element-227">
            <a href="#compra" onClick={scrollToCompra} className="relative group cursor-pointer block w-[200px] md:w-full md:max-w-md" data-id="element-228">
              <div className="absolute -inset-4 bg-gradient-to-r from-amber-200 to-amber-400 rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition duration-500" data-id="element-229"></div>
              <img src="https://cdn.magicpatterns.com/uploads/te3XLDwvrbPMG3GVKwLK8h/WhatsApp_Image_2026-03-11_at_6.07.25_PM-removebg-preview.png" alt="Mega Pack Aprendizaje Lectura" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:scale-105 transition duration-500" data-id="element-230" />
              <div className="absolute top-2 -right-1 md:top-4 md:-right-4 bg-[#F59E0B] text-white font-bold py-1 px-2 md:py-2 md:px-4 rounded-lg shadow-lg transform rotate-6 z-20 text-[10px] md:text-base" data-id="element-231">
                ¡Descarga Inmediata!
              </div>
            </a>
          </div>

          {/* Subtitle */}
          <p className="text-sm md:text-xl text-slate-600 mb-4 md:mb-8 max-w-3xl leading-relaxed text-center" data-id="element-232">
            192 lecturas comprensivas con actividades listas para imprimir. Un
            año completo de Lengua. Para 1º a 6º grado.
          </p>

          {/* Primary CTA */}
          <Button href="#compra" variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-233">
            👉 Quiero mis lecturas
          </Button>
        </div>
      </div>

      {/* BELOW THE FOLD — Info card with features + secondary CTA */}
      <div className="relative z-10 px-4 pb-20 md:pb-32" data-id="element-234">
        <div className="max-w-2xl mx-auto" data-id="element-235">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-slate-100" data-id="element-236">
            <div className="inline-block bg-[#1E3A5F] text-white font-bold px-4 py-1 rounded-md mb-6" data-id="element-237">
              Mega Pack Aprendizaje Lectura™
            </div>

            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-6" data-id="element-238">
              Sistema completo de comprensión lectora para primaria argentina.
            </h3>

            <ul className="space-y-4 mb-8" data-id="element-239">
              {['192 lecturas narrativas (1º a 6º grado)', 'Actividades de comprensión listas para imprimir', 'Plan lector anual completo', 'Banco de 150 consignas inteligentes', 'Kit de emergencia para los días difíciles', 'Sistema de seguimiento para padres y directivos'].map((item, index) => <li key={index} className="flex items-start" data-id="element-240">
                  <CheckCircle2 className="w-6 h-6 text-[#16A34A] mr-3 flex-shrink-0 mt-0.5" data-id="element-241" />
                  <span className="text-slate-700 font-medium" data-id="element-242">{item}</span>
                </li>)}
            </ul>

            <Button href="#compra" variant="secondary" size="lg" fullWidth className="animate-pulse shadow-[0_0_20px_rgba(245,158,11,0.4)]" data-id="element-243">
              🔥 Quiero mis lecturas →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}